module.exports = __webpack_public_path__ + "img/balloon.dd9c0a5a.svg";